module.exports = __webpack_public_path__ + "static/media/fleche-bas.2f862a22.svg";